import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const responseNormalizerInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  return next(req).pipe(
    map((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        if (event.status === HttpStatusCode.NoContent) {
          return event.clone({
            status: HttpStatusCode.Ok,
            body: {
              Status: true,
              Data: null,
              Errors: [],
              CorrelationId: '',
              Metadata: null,
            },
          });
        }
      }
      return event;
    })
  );
};
